import { useFormContext } from 'react-hook-form';

import { dateUtils } from 'shared_DEPRECATED/utils';

import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { SessionType } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

export const useSessionPageRescheduleMutateOptions = (sessionId: string) => {
  const { getSessionById, updateSession } = useSessionsQueryActions();
  const { setValue } = useFormContext();

  const onMutate = ({
    reason,
    startAt,
    endAt,
  }: {
    reason: string;
    startAt: string;
    endAt: string;
  }) => {
    const oldSession = getSessionById(sessionId);

    setValue('attendance', SESSION_ATTENDANCE_STATUS.RESCHEDULED);
    setValue('attendanceNote', reason);
    setValue('startAt', dateUtils.localDate(startAt).toISOString());
    setValue('endAt', dateUtils.localDate(endAt).toISOString());

    updateSession(sessionId, {
      attendance: SESSION_ATTENDANCE_STATUS.RESCHEDULED,
    });

    return { oldSession };
  };

  const onError = (
    err: Error,
    _: any,
    context: { oldSession: SessionType }
  ) => {
    setValue('attendance', context.oldSession.attendance);
    setValue('startAt', context.oldSession.startAt);
    setValue('endAt', context.oldSession.endAt);

    updateSession(sessionId, {
      attendance: context.oldSession.attendance,
      startAt: context.oldSession.startAt,
      endAt: context.oldSession.endAt,
    });
  };

  return {
    onMutate,
    onError,
  };
};
